module.exports = "<div class=\"wrapper\">\n    <div class=\"abs-center wd-xxl\">\n        <!-- START panel-->\n        <div *ngIf=\"message\" class=\"text-center mb-xxl\">\n            <p>{{ message}}</p>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/routes/domain/domain.component.html
// module id = ../../../../../src/app/routes/domain/domain.component.html
// module chunks = main